var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { Emoji } from "emoji-mart";
import authentication from "@irati/auth";
import { Hr } from "@irati/ui/src/Layout";
import { Para } from "@irati/ui/src/Labels";
import { SmallCaption } from "@irati/ui/src/Labels/Labels";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { H4 } from "@irati/ui/src/Headings";
import EmojiWithText from "@irati/ui/src/EmojiWithText";
import banner from "../../images/banner.jpg";
import { SET_EMAIL } from "../../containers/Home/GetStarted";
import CTA from "./CTA";
import LiveChat from "../LiveChat";
import HelpEmail from "../HelpEmail";
import { PaddingGrid, WhiteBackground, ElevatedCard } from "../shared";
import { InformationText, WhiteH2, WhiteH4, Flex, SpaceBetween, Small, StyledLink, BannerHeadings, StyledRow, MobileBanner, StyledBanner } from "./styled";
var bannerProps = {
    backgroundPosition: "0 34%",
    bannerImg: banner,
    minHeight: "500",
    tabletMinHeight: "200",
    cutOffBottom: true
};
var Landing = /** @class */ (function (_super) {
    __extends(Landing, _super);
    function Landing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Landing.prototype.render = function () {
        var _a = this.props, onUpdateStep = _a.onUpdateStep, formatMessage = _a.formatMessage;
        var hasTier2Access = authentication.apps("medical.tiers.tier2");
        var name = authentication.user().firstname;
        return (React.createElement(WhiteBackground, null,
            React.createElement(Row, null,
                React.createElement(Col, { xsHidden: true, lg: 12 },
                    React.createElement(StyledBanner, __assign({}, bannerProps),
                        React.createElement(PaddingGrid, null,
                            React.createElement(SpaceBetween, null,
                                React.createElement(BannerHeadings, null,
                                    React.createElement(WhiteH2, { base: true },
                                        React.createElement(FormattedMessage, { id: "medical.landing.heading", values: { name: name } })),
                                    React.createElement(WhiteH4, { large: true },
                                        React.createElement(FormattedMessage, { id: "medical.landing.para" }))),
                                React.createElement(CTA, { attachGetStartedTooltip: true, onClick: function () { return onUpdateStep(SET_EMAIL); } }))))),
                React.createElement(Col, { xs: 12, smHidden: true, mdHidden: true, lgHidden: true },
                    React.createElement(MobileBanner, __assign({}, bannerProps),
                        React.createElement(PaddingGrid, null,
                            React.createElement(WhiteH2, { base: true },
                                React.createElement(FormattedMessage, { id: "medical.landing.heading", values: { name: name } })))))),
            React.createElement(PaddingGrid, null,
                React.createElement(StyledRow, null,
                    React.createElement(Col, { xs: 12, smHidden: true, mdHidden: true, lgHidden: true },
                        React.createElement(H4, null,
                            React.createElement(FormattedMessage, { id: "medical.landing.para" })),
                        React.createElement(CTA, { onClick: function () { return onUpdateStep(SET_EMAIL); } })),
                    React.createElement(Col, { xs: 12, md: 8 },
                        React.createElement(InformationText, null,
                            React.createElement(Para, { large: true, light: true },
                                React.createElement(FormattedMessage, { id: "medical.landing.desc.1" })),
                            React.createElement(Para, { large: true, light: true },
                                React.createElement(FormattedMessage, { id: "medical.landing.desc.2" }))),
                        React.createElement(Para, null,
                            React.createElement(FormattedMessage, { id: "medical.landing.section.one.subtitle" })),
                        React.createElement(EmojiWithText, { emoji: "calling", text: formatMessage({ id: "medical.landing.section.one.text1" }) }),
                        React.createElement(EmojiWithText, { emoji: "female-doctor", text: formatMessage({ id: "medical.landing.section.one.text2" }) }),
                        React.createElement(EmojiWithText, { emoji: "pencil", text: formatMessage({ id: "medical.landing.section.one.text3" }) }),
                        React.createElement(EmojiWithText, { emoji: "spiral_calendar_pad", text: formatMessage({ id: "medical.landing.section.one.text4" }) }),
                        React.createElement(EmojiWithText, { emoji: "file_folder", text: formatMessage({ id: "medical.landing.section.one.text5" }) }),
                        hasTier2Access &&
                            React.createElement(EmojiWithText, { emoji: "hospital", text: formatMessage({ id: "medical.landing.section.one.text6" }) })),
                    React.createElement(Col, { xs: 12, md: 4 },
                        React.createElement(ElevatedCard, null,
                            React.createElement(Para, { large: true },
                                React.createElement(FormattedMessage, { id: "medical.landing.contactCard.para" })),
                            React.createElement(Flex, null,
                                React.createElement(Emoji, { emoji: { id: "iphone" }, size: 14, set: "apple" }),
                                React.createElement(LiveChat, null)),
                            React.createElement(SmallCaption, { bold: true, uppercase: true },
                                React.createElement(FormattedMessage, { id: "medical.landing.contactCard.linesOpenTimes.p1" }),
                                React.createElement("br", null),
                                React.createElement(FormattedMessage, { id: "medical.landing.contactCard.linesOpenTimes.p2" }),
                                React.createElement("br", null),
                                React.createElement(FormattedMessage, { id: "medical.landing.contactCard.linesOpenTimes.p3" })),
                            React.createElement(Hr, null),
                            React.createElement(Flex, null,
                                React.createElement(Emoji, { emoji: { id: "e-mail" }, size: 14, set: "apple" }),
                                React.createElement(HelpEmail, null))))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(Small, null,
                            React.createElement(FormattedMessage, { id: "medical.landing.footer.p1" })),
                        React.createElement(Small, { bold: true },
                            React.createElement(FormattedMessage, { id: "medical.landing.footer.p2" })),
                        React.createElement(Small, { flush: true },
                            React.createElement(FormattedMessage, { id: "medical.landing.footer.p3" }),
                            React.createElement(StyledLink, { inBody: true, uppercase: false, href: formatMessage({ id: "medical.privacyPolicy.href" }), target: "_blank", rel: "noopener noreferrer" },
                                React.createElement(FormattedMessage, { id: "platform.footer.href.privacyPolicy.text" }))),
                        React.createElement(Small, null,
                            React.createElement(FormattedMessage, { id: "medical.landing.footer.p4" }),
                            React.createElement(StyledLink, { inBody: true, uppercase: false, href: formatMessage({ id: "platform.footer.href.termsAndConditions.href" }), target: "_blank", rel: "noopener noreferrer" },
                                React.createElement(FormattedMessage, { id: "platform.footer.href.termsAndConditions.text" }))),
                        React.createElement(Small, null,
                            React.createElement(FormattedMessage, { id: "medical.landing.footer.p5" })))))));
    };
    return Landing;
}(Component));
export default injectIntl(Landing);
